var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"'desactiveVL'",attrs:{"id":"vlibras-root"}},[_c('div',{staticClass:"enabled",attrs:{"vw":""}},[_c('div',{staticClass:"active",attrs:{"vw-access-button":""}}),_c('div',{attrs:{"vw-plugin-wrapper":""}},[_c('div',{staticClass:"vw-plugin-top-wrapper"})])])])
}]

export { render, staticRenderFns }